import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonBackButton,
  IonContent,
} from '@ionic/react';
import PropTypes from 'prop-types';
import { Typography, Stack, Box } from '@mui/material';
import './Celebration.css';
import appStrings from 'common/app_strings';
import appColors from 'common/app_colors';

const { goals: { goalsCelebration: STRINGS } } = appStrings;
const { text, buttons, container } = appColors;

const Celebration = ({ history, location }) => {
  const getCelebrationText = (type) => {
    switch (type) {
      case 'health':
        return STRINGS.health;
      case 'academic':
        return STRINGS.academic;
      case 'passion':
        return STRINGS.passion;
      case 'career':
        return STRINGS.career;
      default:
        return STRINGS.iImproved(type);
    }
  };

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar
          className="back-button-toolbar"
          style={{ '--background': container.darkNavy }}
        >
          <IonButtons slot="start">
            <IonBackButton
              icon="/assets/back-arrow-white.svg"
              style={{
                '--icon-font-size': '1.25rem',
                '--icon-padding-start': '8px',
                '--icon-padding-end': '12px',
                '--icon-padding-top': '4px',
                '--icon-margin-end': '6px',
                '--color': buttons.whiteBackground,
              }}
              className="back-button-custom"
              mode="ios"
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent
        style={{
          '--background': container.darkNavy,
          '--padding-start': '32px',
          '--padding-end': '32px',
        }}
        fullscreen
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
          }}
        >
          <Stack>
            <Typography
              color={text.whiteText}
              fontSize={24}
              fontWeight={700}
              sx={{ textAlign: 'center' }}
            >
              {STRINGS.congratulations}
            </Typography>
            <Typography sx={{ color: text.whiteText, textAlign: 'center', mt: 1 }}>
              {STRINGS.goalAchieved}
            </Typography>
            <Typography sx={{ color: text.whiteText, textAlign: 'center' }}>
              {STRINGS.greatJob}
            </Typography>
            <div className="goals-celebration-img-wrapper">
              <img
                src="/assets/takeoff.svg"
                alt="rocketship taking off"
                className="goals-celebration-img"
              />
            </div>
            <Typography
              sx={{
                color: text.gold,
                fontSize: 22,
                fontWeight: 700,
                textAlign: 'center',
                px: 2,
                mt: 6,
              }}
            >
              {getCelebrationText(location?.state?.type)}
            </Typography>
            <Typography
              color={text.whiteText}
              fontSize={14}
              sx={{ textAlign: 'center', px: 2, mt: 3 }}
            >
              {STRINGS.considerSharing}
            </Typography>
          </Stack>
          {location?.state?.post?.id ? (
            <IonButton
              className="goals-celebration-share"
              style={{ '--color': text.whiteText, '--border-color': container.white }}
              size="large"
              expand="block"
              shape="round"
              fill="outline"
              onClick={() => history.push(`/posts/${location?.state?.post?.id}`)}
            >
              {STRINGS.shareAnUpdate}
            </IonButton>
          ) : (
            <IonButton
              className="goals-celebration-share"
              style={{ '--color': text.whiteText, '--border-color': container.white }}
              size="large"
              expand="block"
              shape="round"
              fill="outline"
              onClick={() => history.goBack()}
            >
              {STRINGS.returnToGoals}
            </IonButton>
          )}
        </Box>
      </IonContent>
    </IonPage>
  );
};

Celebration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.oneOfType([PropTypes.any]).isRequired,
};

export default Celebration;
